export default "__VITE_ASSET__Bzrj5acA__"